import { restClient } from '@/Core'

import { toCollection, toNode } from '../Helpers/diskResponse'

/**
 * Скільки елементів безпосередньо в папці — `total` списку
 * `GET /services/disk/nodes?parent=` з одним рядком (властивості папки).
 */
export const CountDiskFolderItemsTask = async (parent: string): Promise<number> => {
    const response = (await restClient.get(
        '/services/disk/nodes',
        { searchParams: { parent, limit: '1' } },
        { forceRefresh: true }
    )) as unknown

    return toCollection(response, toNode).total
}
